import styled from "styled-components";
import Input from "../componentes/Input";
import Button from "../componentes/Button";
import Logo from "../componentes/Logo";
import { useNavigate } from "react-router-dom";

const SectionLogin = styled.section `
    min-height: calc(100vh - 64px);
    min-width: 100vw;
    padding: 32px 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`
const BoxLogin = styled.div `
    display: flex;
    flex-wrap: wrap;
    background-color: #111622;
    padding: 32px;
    margin: 0;
    width: 500px;
    max-width: 80vw;
    height: fit-content;
    border-radius: 20px;
    box-shadow: 0 3px 6px #00000029;
`
const H1 = styled.h1 `
    width: 100%;
    text-align: center;
    color: #87e20f;
    text-transform: uppercase;
    font-size: 35px;
    margin: 30px 0;
    line-height: 1;
`
const ForgotPass = styled.div `
    width: 100%;
    text-align: right;
    a {
        text-decoration: none;
        color: #87e20f;
        cursor: pointer;
    }
`
const CreatAccount = styled.div `
    width: 100%;
    text-align: center;
    margin-top: 40px;
    a {
        text-decoration: none;
        cursor: pointer;
        color: #fff;

        strong {
            color: #87e20f;
        }
    }
`

function Login() {
    const navigate = useNavigate();
    
    const redirectHome = (e) => {
        e.preventDefault();
        navigate('/home');
    };

    return(
        <SectionLogin>
            <BoxLogin>
                <Logo className="login"/>
                <H1>Login</H1>
                <Input
                    type="email"
                    placeholder="Informe um e-mail"
                    className=""
                />
                <Input
                    type="password"
                    placeholder="Senha"
                    className=""
                />
                <ForgotPass>
                    <a href="/">Esqueci minha senha</a>
                </ForgotPass>
                <Button
                    type="submit"
                    text="Escalar"
                    className="login"
                    onClick={redirectHome}
                />
                <CreatAccount>
                    <a href="/">Não tem uma conta? <strong>Criar</strong></a>
                </CreatAccount>
            </BoxLogin>
        </SectionLogin>
    )
}

export default Login;